// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@awc/Overrides/Components/ProductCarouselProduct";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, sharedBadgeStyle } from "@awc/XDL/Utilities";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import { css } from "styled-components";

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        typographyProps: {
            size: fontConfig.fontSize.regular,
            weight: fontConfig.weight.bold,
            lineHeight: fontConfig.lineHeight.xSmall,
            css: css`
                margin-bottom: 0;
                ${ellipsis(1)}
            `,
        },
        css: css`
            margin-bottom: 0;
            align-self: baseline;
            width: auto;
        `,
    },
    productDetailDescription: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        lineHeight: fontConfig.lineHeight.xSmall,
        css: css`
            ${ellipsis(1)}
        `,
    },
};

productCarouselProductStyles.productBrandStyles = {
    nameLink: {
        typographyProps: {
            size: fontConfig.fontSize.small,
            weight: fontConfig.weight.regular,
            lineHeight: fontConfig.lineHeight.singleLineSmall,
            css: css`
                ${ellipsis(1)}
            `,
        },
        css: css`
            margin-bottom: 0;
            align-self: baseline;
            width: auto;
        `,
    },
    nameText: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.regular,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        css: css`
            margin-bottom: 0;
            ${ellipsis(1)}
        `,
    },
};

productCarouselProductStyles.productPriceWrapper = {
    css: css`
        flex-grow: 1;
    `,
};

productCarouselProductStyles.badgeContainer = {
    ...mergeWithCss(sharedBadgeStyle.badgeContainer, {
        css: css`
            &&&& {
                ${LazyImageStyle} {
                    margin-top: 4px;
                }
            }
        `,
    }),
};

productCarouselProductStyles.customProductBadge = {
    textBadgeWrapperCss: {
        ...mergeWithCss(sharedBadgeStyle.badge, {
            css: css`
                justify-content: flex-start;
                width: max-content;
                max-width: 100%;
            `,
        }),
    },
    textBadgeCss: {
        ...mergeWithCss(sharedBadgeStyle.badgeText, {
            css: css`
                ${ellipsis(1)}
            `,
        }),
    },
};

productCarouselProductStyles.addToList = {
    css: css`
        min-height: 18px;
    `,
};

productCarouselProductStyles.productGridContainerStyle = {
    addToList: {
        css: css`
            justify-content: flex-end;
        `,
    },
    image: {
        css: css`
            width: 218px;
            height: 218px;
            &, img {
                aspect-ratio: 1;
            }
        `,
    }
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-bottom: 0;
            min-height: 18px;
        `,
    },
};
productCarouselProductStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            aspect-ratio: 1;
        `,
    },
    img: {
        css: css`
            object-fit: contain;
        `,
    }
}